import React, { useState } from "react";
import { Link } from "react-router-dom";
import perfume from "../../Images/Perfume.png";
import bodySpray from "../../Images/body-spray.png";
import meet from "../../Images/meet-the-team.png";
import join from "../../Images/join-the-team.png";


const WhoWeAre = () => {
  const [visible, setVisible] = useState(false);
  return (
    <div
      className="dropdown-trigger"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      <div className="nav-link">WHO WE ARE</div>
      <div className={`dropdown-menu mt-[18px]  ${visible ? "flex" : ""}`}
        style={{ display: visible ? "flex" : "", flexDirection: "column" }}
      >
        <Link className="dropdown-item" to="/brands">
          <img alt="" src={meet} />
          <span>Brands</span>
        </Link>
        <hr className="dropdown-divider" />
        <Link className="dropdown-item" to="/meet-the-team">
          <img alt="" src={meet} />
          <span>MEET THE TEAM</span>
        </Link>
        <hr className="dropdown-divider" />
        <Link className="dropdown-item" to="/join-the-team">
          <img alt="" src={join} />
          <span>JOIN THE TEAM</span>
        </Link>
      </div>
    </div>
  );
};

export default WhoWeAre;
